module.exports = ["방금","%s 초 전","%s 분 전","%s 시간 전","%s 일 전","%s 주 전","%s 개월 전","%s 년 전"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/ko-KR.json
// module id = +0Cn
// module chunks = 1